import { useOrg } from "@/lib/states/session/hooks";
import { trpc } from "@/lib/trpc/client";
import type { Exercise } from "@/components/exercises/exerciseColumns";

export type ExerciseWithVideo = Exercise;

export function useExerciseDatabase() {
  const org = useOrg();
  const { data, isLoading } = trpc.exercises.list.useQuery(undefined, {
    enabled: Boolean(org?.id),
  });

  return {
    exercises: data as ExerciseWithVideo[] | undefined,
    isLoading,
  };
}
